document.addEventListener("DOMContentLoaded", function() {
    // First script: Move the quantity element inside the button container
    var quantityElement = document.querySelector(".product-form__quantity");
    var buttonContainer = document.querySelector(".product-form__buttons");

    if (quantityElement && buttonContainer) {
        // Move the quantity element inside the button container and place it before the button
        buttonContainer.insertBefore(quantityElement, buttonContainer.firstChild);
    }

    // Second script: Handle the deposit element and mutation observer
    var depositElement = document.getElementById('depositElement');

    // Create a MutationObserver to watch for added nodes in the body
    var observer = new MutationObserver(function(mutationsList, observer) {
        // Elements for the script
        var priceElement = document.querySelector('.gPreorderSellingPlanPrice');
        var valueElement = document.querySelector('li.gPreorderSellingPlanValue:first-child');

        // Script functionality
        if (priceElement && valueElement) {
            valueElement.appendChild(priceElement);
            priceElement.style.float = 'right';
        }

        // Stop observing once all elements have been found and moved
        if (priceElement && valueElement) {
            observer.disconnect();
        }
    });

    // Start observing the body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });

    if (!depositElement) {
        console.log("depositElement not found");
    }
});
